import type { TextSpec } from './text';
import { dimensionGeometry } from './dimension';
import type { Entity, TextEntity } from './types';

export function textEntitySpec(entity: TextEntity): TextSpec {
  return {
    text: entity.text,
    position: entity.position,
    height: entity.height,
    rotation: entity.rotation,
    anchor: entity.anchor,
    valign: entity.valign,
    widthFactor: entity.widthFactor,
  };
}

/** Text carried by an entity: standalone text or a dimension's measurement. */
export function entityTextSpec(entity: Entity): TextSpec | null {
  if (entity.type === 'text') return textEntitySpec(entity);
  if (entity.type === 'dimension') return dimensionGeometry(entity).text;
  return null;
}
